// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4df4dd15","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tool/batch/updateReducer/filters/marketplace/Magalu.vue
// module id = 1699
// module chunks = 0